import Referees from 'components/general/Referees'
import Label from "components/general/Label"
import Table from 'react-bootstrap/Table';
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop, faCheck, faMinusCircle, faPlusCircle, faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect } from "react";
import Collapse from 'react-bootstrap/Collapse';
import { isLiveStatus } from "helpers/status";
import { CompetitionFromStore } from 'helpers/utils';

import { useViewport } from 'components/general/useViewPort';
import SportCode from 'components/common/SportCode';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const competition = CompetitionFromStore();
const iconClose = competition === 'EG2023' ? faMinusCircle : faCaretDown;
const iconOpen = competition === 'EG2023' ? faPlusCircle : faCaretRight;

const arrowDown = <FontAwesomeIcon icon={iconClose} />
const arrowUp = <FontAwesomeIcon icon={iconOpen} />

const blueCard = <FontAwesomeIcon className='text-primary' icon={faStop} />
const redCard = <FontAwesomeIcon className='text-danger' icon={faStop} />

const check = <FontAwesomeIcon icon={faCheck} />

const Round = ({ row, current, openAll, redScore, blueScore, roundWinner, judges, judgesArr }) => {
  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs";
  // arrows management. hide/show actions
  const [open, setOpen] = useState(false);
  const [arrow, setArrow] = useState(arrowUp);
  const isCurrentRound = current === row.round

  const { mirs_discipline } = useUrlFriendlyToParameters()

  useEffect(() => {
    if (openAll) {
      setArrow(arrowDown)
    } else {
      setArrow(arrowUp)
    }
    setOpen(openAll);
  }, [openAll])

  const handleClick = () => {
    if (open) {
      setArrow(arrowUp)
    } else {
      setArrow(arrowDown)
    }
    setOpen(!open);
  }

  return (
    <>
      <tr>
        <td className={isCurrentRound ? 'score-current text-start fw-bold' : 'text-start fw-bold'}><SportCode discipline={mirs_discipline} entity='@Period' code={row.round} /></td>
        {!isMobile && 
          judgesArr?.map(j => (
              <td className="text-center" key={j?.order}><OverallWinner code={j?.function} data={row} /></td>  )
          )
        }
        <td className={roundWinner === 'R' ? 'text-center fw-bold' : 'text-center'}>{redScore}</td>
        <td className={roundWinner === 'B' ? 'text-center fw-bold' : 'text-center'}>{blueScore}</td>
        <td className="text-center">{roundWinner === 'R' ? redCard : roundWinner === 'B' ? blueCard : ''}</td>
        <td className="arrow" onClick={(e) => handleClick()}>{arrow}</td>
      </tr>
      <Collapse in={open}>
        <tr>
          <td colSpan={!isMobile ? 14 : 5}>
            <Table className="expandible" striped>
              <thead>
                <tr>
                  <th className=""></th>
                  <th className="text-center" ><Label data="LabelBkgOverall" /></th>
                  <th className="text-center" ><Label data="LabelBkgTechnique" /></th>
                  <th className="text-center" ><Label data="LabelBkgVariety" /></th>
                  <th className="text-center" ><Label data="LabelBkgPerformance" /></th>
                  <th className="text-center" ><Label data="LabelBkgMusicality" /></th>
                  <th className="text-center" ><Label data="LabelBkgCreativity" /></th>
                  <th className="text-center" ><Label data="LabelBkgPersonality" /></th>
                </tr>
              </thead>

              <tbody>
                {
                  row.judges?.map(
                    result => {
                      return (
                        <tr key={result?.judge}>
                          <td className="text-center"><JudgeName data={judges} code={result?.judge} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'OVERALL'} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'TECHNIQUE'} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'VARIETY'} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'PERFORMANCE'} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'MUSICALITY'} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'CREATIVITY'} /></td>
                          <td className="text-center"><JudgeScore data={result} code={'PERSONALITY'} /></td>
                        </tr>
                      )
                    }
                  )
                }
              </tbody>
            </Table>
          </td>
        </tr>
      </Collapse>
    </>)
}

//  
const transformExtendedResults = (items) => {

  let mergedExtendedResults = []
  items.forEach(item => {
    const usefulExtendedResults = item?.extendedResults?.filter(ex => {
      //console.log("ex.er_value", ex.er_value, parseInt(ex.er_value), Number(ex.er_value))
      return ex.er_type = 'JUDGE_CRITERIA' && Number(ex.er_value) > 0 && 'TECHNIQUE|VARIETY|PERFORMANCE|MUSICALITY|CREATIVITY|PERSONALITY|OVERALL'.includes(ex.er_valuetype)
    })
    const redOrBlue = item.startSortOrder === 1 ? 'R' : 'B'
    usefulExtendedResults?.map(i => i.color = redOrBlue)
    usefulExtendedResults?.forEach(i => mergedExtendedResults.push(i))
  })

  let rounds = []
  mergedExtendedResults.forEach(er => {
    let round = rounds.find(r => r.round === er.er_pos)
    if (round) {
      let judge = round.judges.find(j => j.judge === er.er_code)
      if (judge) {
        judge.results.push(er)
      } else {
        round.judges.push({
          judge: er.er_code,
          results: [er]
        })
      }
    } else {
      rounds.push({
        round: er.er_pos,
        judges: [{
          judge: er.er_code,
          results: [er]
        }]
      })
    }
  })
  rounds.sort((a, b) => a.round > b.round ? 1 : -1)
  rounds.forEach(r => r.judges.sort((a, b) => a.judge > b.judge ? 1 : -1))
  if (rounds.length === 0) {
    rounds.push({
      round: 'R1'
    })
    rounds.push({
      round: 'R2'
    })
  } else if (rounds.length === 1) {
    rounds.push({
      round: 'R2'
    })

  }
  return rounds;
}

const OverallWinner = ({ data, code }) => {
  const color = data?.judges?.find(jr => jr.judge === code)?.results?.find(r => r.er_valuetype === 'OVERALL')?.color
  return color === 'B' ? blueCard : color === 'R' ? redCard : ''
}

const JudgeScore = ({ data, code }) => {
  const { breakPoint } = useViewport();
  const result = data?.results?.find(r => r.er_valuetype === code);
  if (!result)
    return '';
  else if ((breakPoint !== "sm" && breakPoint !== "xs")) {
    return (<>{result.color === 'R' ? redCard : result.color === 'B' ? blueCard : ''} {`+${result.er_value}%`}</>);

  } else {
    return (<div>
      <div>{result.color === 'R' ? redCard : result.color === 'B' ? blueCard : ''}</div>
      <div>{`+${result.er_value}%`}</div>
    </div>)
  }
}

const JudgeName = ({ data, code }) => {
  const { breakPoint } = useViewport();
  const off = data?.find(j => j?.function?.functionCode === code)?.official
  return (
    <div className="d-flex flex-row">
      <span className='fw-bold pe-1'>{code}</span>
      {off && breakPoint !== "sm" && breakPoint !== "xs" && (
        <>
          <Noc {...off?.organisation} />
          <Competitor hidePicture={true} hideNoc={true} {...off} />
        </>
      )
      }
    </div>
  )
}

/*
Main component
Renders result page for BKG sport
*/
const BkgIndividual = ({ data }) => {

  const [open, setOpen] = useState(false);
  const [arrow, setArrow] = useState(arrowUp);

  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs";

  // managenent of header arrow when clicked
  const handleClick = () => {
    if (open) {
      setArrow(arrowUp)
    } else {
      setArrow(arrowDown)
    }
    setOpen(!open);
  }
  const rounds = transformExtendedResults(data?.results.items)

  const judges = data?.results?.officials?.filter(o => /^J[1-9]$/.test(o?.function?.functionCode) || /^[A-J]$/.test(o?.function?.functionCode))
  const otherReferees = data?.results?.officials?.filter(o => !/^J[1-9]$/.test(o?.function?.functionCode) && !/^[A-J]$/.test(o?.function?.functionCode))
  const judgesArr = judges?.sort((a, b) => a.order - b.order).map(j => ({order: j?.order, function: j.function?.functionCode}));
  otherReferees?.sort((a, b) => a.order - b.order)

  let current = ''
  if (isLiveStatus(data?.results?.status?.code)) {
    current = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'PERIOD')?.ei_value;
  }

  return (
    <div className="bkg-individual-main">
      <Table>
        <thead>
          <tr>
            <th className="round" rowSpan="2"></th>
            {!isMobile && 
            judgesArr?.map(j => (
              <th className="judge text-center" rowSpan={2} key={j?.order}>{j?.function}</th>
            ))
            }
            <th className="votes text-center" colSpan={2}><Label data="LabelBkgVotes" /></th>
            <th className="winner text-center" rowSpan="2">{!isMobile ? <Label data="LabelBkgRoundWinner" /> : check}</th>
            <th className="arrow text-center" rowSpan="2" onClick={(e) => handleClick()}>{arrow}</th>
          </tr>
          <tr>
            <th className='vote text-center'>{redCard} <Label data="LabelBkgRed" /></th>
            <th className='vote text-center'>{blueCard} <Label data="LabelBkgBlue" /></th>
          </tr>
        </thead>
        <tbody>
          {rounds?.map(row => {
            const period = data.results?.periods?.find(p => p.p_code === row.round);
            let redScore = period && period?.home?.periodScore ? period?.home?.periodScore : ''
            let blueScore = period && period?.away?.periodScore ? period?.away?.periodScore : ''
            let roundWinner = ''
            if (redScore && blueScore && !isNaN(parseInt(redScore)) && !isNaN(parseInt(blueScore))) {
              roundWinner = parseInt(redScore) > parseInt(blueScore) ? 'R' : parseInt(redScore) < parseInt(blueScore) ? 'B' : ''
            }
            return <Round row={row} openAll={open} redScore={redScore} blueScore={blueScore} roundWinner={roundWinner} judges={judges} judgesArr={judgesArr} key={row.round} current={current} />
          }
          )
          }
        </tbody>
      </Table>
    </div>
  )
}

export default BkgIndividual;